import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectLanguagesService {
  public selectedLanguageSub: BehaviorSubject<string> = new BehaviorSubject<string>('');
  allowedLanguages: Array<string> = ['en_US', 'en_CA', 'en_GB', 'en_AU', 'es_MX', 'fr_CA', 'fr_FR', 'ja_JP', ];

  constructor() {
    let browserLanguage: string;
    if(navigator.language == 'ja'){
      browserLanguage = 'ja_JP';
    } else {
      browserLanguage = navigator.language.replace('-','_');
    }
    if(!this.allowedLanguages.includes(browserLanguage)){
      browserLanguage = 'en_US';
    }
    this.setSelectedLanguage(localStorage.getItem('languageFromURL') || localStorage.getItem('selectedLanguage') || browserLanguage);
  }

  public getSelectedLanguageObs(): Observable<string> {
    return this.selectedLanguageSub.asObservable();
  }

  public setSelectedLanguage(selectedLanguageName: string): void {
    this.selectedLanguageSub.next(selectedLanguageName);
  }
}
